import Dialog from "sap/m/Dialog";
import BaseController from "../pages/sharedControllers/BaseController";
import { AttachmentSelectionDto } from "../models/AttachmentDto";
import HTML from "sap/ui/core/HTML";
import Button from "sap/m/Button";
import IllustratedMessage from "sap/m/IllustratedMessage";
import IllustratedMessageType from "sap/m/IllustratedMessageType";
import IllustratedMessageSize from "sap/m/IllustratedMessageSize";

export default class ManagedAttachmentUtil {
  private _controller: BaseController;
  private _attachment: AttachmentSelectionDto;
  private _viewer: Dialog;
  private _source?: string;
  private _attachmentIsImage = false;

  constructor(controller: BaseController, attachment: AttachmentSelectionDto) {
    this._controller = controller;
    this._attachment = attachment;

    if (attachment.mimetype?.startsWith("image/")) this._attachmentIsImage = true;
  }

  public async handlePreview() {
    let uri;

    if (this._attachment.sourceType === "WorkOrderAttachment") {
      uri = "api/WorkOrder/DownloadWorkOrderAttachment/{attachmentId}";
    }
    else if (this._attachment.sourceType === "WorkOrderItemAttachment") {
      uri = "api/WorkOrder/DownloadWorkOrderItemAttachment/{attachmentId}";
    }

    if (uri) {
      uri = uri.replace("{attachmentId}", String(this._attachment.id));
      await this.getSource(uri);
    }

    this.openViewer();
  }

  private async getSource(endpoint: string) {
    const response = await this._controller.getApiService().get(endpoint);

    const contentType = response.headers.get("content-type");
    if (contentType?.includes("application/json")) {
      this._source = undefined;
      return;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    this._source = url;
  }

  private openViewer() {
    if (this._viewer) this._viewer.destroy();

    // NOTE: if we dont need the toolbar
    //  const iframeHtml = new HTML({
    //   content: `<iframe 
    //   src="${this._source + "#toolbar=0"}"
    //   class="attachmentPreviewFrame">
    //   </iframe>`
    // });

    let htmlContent = new HTML({
      content: `<iframe 
      src="${this._source}"
      class="attachmentPreviewFrame">
      </iframe>`
    });

    if (this._attachmentIsImage) {
      htmlContent = new HTML({
        content: `<img 
        src="${this._source}"
        class="attachmentPreviewImg">
        </img>`
      });
    }

    const errorMessage = new IllustratedMessage({
      illustrationType: IllustratedMessageType.UnableToLoad,
      title: this._controller.translate("errorLoadingAttachmentPreview"),
      illustrationSize: IllustratedMessageSize.Large
    });

    this._viewer = new Dialog({
      title: this._attachment.name,
      titleAlignment: "Center",
      stretch: true,
      content: this._source ? htmlContent : errorMessage,
      endButton: new Button({
        text: this._controller.translate("close"),
        press: () => this._viewer.close()
      }),
      afterClose: () => {
        this._viewer.destroy();
      }
    }).addStyleClass("attachmentViewerDialog");

    this._viewer.open();
  }
}
